import React from 'react'
import ProdIOTSumMatRow from './ProdIOTSumMatRow'
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import { UiView, UiViewContent } from "../../../../../library/layout/Index";
import useRowSelector from "../../../../../library/hooks/selector/useRowSelector";

const ProdIOTSumMat = (props) => {
    const { formObject, viewData } = props;

    const rowSelector = useRowSelector("2", null);

    return (
        <UiView>
            <UiViewContent>
                <ul className="uiListTable">
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnCenter uiColumn30"><SarasTrans value="Sr No." /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Item Id" /></li>
                            <li className="uiColumnCenter uiColumn150"><SarasTrans value="Item Name" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                                action={{ paramName: "variation1Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                                action={{ paramName: "variation2Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                            </FormWrapper>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Qty Issued" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Qty Returned" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Qty Consumed" /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Qty Wasted" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit Cost" /></li>
                            <li className="uiColumnCenter uiColumn100"><SarasTrans value="Remark" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Type" /> </li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).sort((a, b) => a.sortKey - b.sortKey).map((row, index) => (
                            <li>
                                <ProdIOTSumMatRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} rowSelector={rowSelector} index={index + 1} />
                            </li>
                        ))
                    }
                </ul>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProdIOTSumMat, "prodIOTSumMat", "");